export default {
    title: 'Create a new service',
    title_modify: 'Change service',
    subtitle: 'Enter the service data',
    create_category: 'Please choose the categories',
    category_types: 'Service categories:',
    progressbar: {
        service_data: 'Service data',
        category: 'Category',
        photos: 'Photos',
        schedule: 'Schedule',
    },
    selected_category_number: 'Number of selected offers: {number}',
    category_warning: 'Please add at least one category',
    no_search_result: 'We did not find any services matching your search',
}
